/* eslint-disable */

import { StyleSheet } from 'aphrodite'
import React, { useState } from 'react'
import { useLoad } from "../../hooks/request";
import { useQueryParams } from "../../hooks/queryString";
import Button from "../../components/common/Button";
import { useModal } from "../../hooks/modal";
import Layout from "../../components/Layout";
import { APARTMENT_LIST } from "../../urls";
import ApartmentCreate from "./ApartmentCreate";
import BuildingTabs from "../../components/BuildingTabs";
import Table from "../../components/common/Table";
import ApartmentItem from "./ApartmentItem";


export default function Apartment() {
    const [page, setPage] = useState(1)
    const [params, setParams] = useState({})

    const searchParam = useQueryParams()
    const apartment = useLoad({
        url: APARTMENT_LIST,
        params: { page, ...params, ...searchParam }
    }, [searchParam, page, params])

    const productList = apartment.response ? apartment.response.results : []
    const [showCreateModal, setShowCreateModal] = useModal(<ApartmentCreate expenseReport={apartment}
                                                                            onCancel={() => setShowCreateModal()}/>, styles.modal)

    return (
        <Layout showCreateModal={showCreateModal}>
            <div className="is-flex is-justify-content-space-between mb-3 is-align-items-center">
                <h2 className="title is-size-4">Квартиралар</h2>
                <Button text="Қўшиш" className="button is-link is-outlined" onClick={showCreateModal}/>
            </div>
            <BuildingTabs/>

            <div>
                <div className="mt-4 mb-4">
                    <Table
                        loading={apartment.loading}
                        items={productList}
                        columns={{
                            index: '№',
                            datae: 'Падезд',
                            dd32date: 'Хона номери',
                            ddda32te: 'Квартира Умумий қиймати',
                            dda3232dte: 'Бошланғич тўлови',
                            ddddate: 'Неча ойга',
                            ddd312ate: 'Ойлик Тўлов',
                            dbuttons: ''
                        }}
                        totalCount={apartment.response ? apartment.response.count : 0}
                        activePage={page}
                        onPageChange={setPage}
                        renderItem={(item, index) => <ApartmentItem apartment={apartment} index={index} key={item.id}
                                                                    item={item}/>}
                    />
                </div>
            </div>
        </Layout>
    )
}

const styles = StyleSheet.create({
    space: {
        marginTop: '2rem'
    }
    ,
    emptyImg: {
        width: '330px', height:
            '300px'
    }
    ,
    loader: {
        marginTop: '2rem'
    }
    ,
    modal: {
        width: 800
    }
    ,
    checkmark: {
        marginRight: '3px'
    }
    ,
})
